import Page from "../components/Page";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, Link } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const PageMaintenance: FC = () => {
    const { t } = useTranslation();

    return (
        <Page title={t("maintenance.title")}>
            <Box sx={{ maxWidth: 480, margin: "auto", textAlign: "center", paddingTop: 4 }}>
                <Typography variant="h3" gutterBottom>
                    ¯\_(ツ)_/¯
                </Typography>
                <Typography gutterBottom sx={{ color: "text.primary" }}>
                    {t("maintenance.hint1")}
                </Typography>
                <Typography gutterBottom sx={{ color: "text.secondary" }} fontSize={14}>
                    {t("maintenance.hint2")}
                </Typography>
                <Link to="/" component={RouterLink} sx={{ color: "warning.main" }}>
                    <b>{t("shared.goBackToMainpage")}</b>
                </Link>
            </Box>
        </Page>
    );
};

export default PageMaintenance;
